<template>
  <div>
    <div class="video_tabs">
      <div  @click="changePlay(1)" class="tabsName" :class="activeVideo==2?'activeVideo':''">
        <img  style="width: 24px;height: 24px;margin-right: 4px;" src="/static/scope/lives.png" alt="" srcset="">
        视频直播
      </div>

      <div  @click="changePlay(2)" class="tabsName" :class="activeVideo==1?'activeVideo':''">
        <img  style="width: 24px;height: 24px;margin-right: 4px;" src="/static/scope/donghua.png" alt="" srcset="">
         动画直播
      </div>
    </div>
    <div class="video_info">
        <div v-if="activeVideo ==2 && info.matchLiveVO.haveAnimation == 1">
            <iframe  class="setiframe" :src="info.matchLiveVO.animationUrl" frameborder="0"></iframe>
        </div>
    </div>
    <dialogLive :userLive='userLive' ref="dialogLive"></dialogLive>
  </div>
</template>
<script>
  import dialogLive from '@/pages/components/lz_dialogLives.vue';
  import { matchBeRelevanceAnchorList  } from '@/api/scope.js';
  export default {
    components:{
      dialogLive
    },
    props: {
      info: {
        // 声明类型
        type: Object,
        //声明是否必需
        require: true,
        // 声明默认值
        default: {}
      }
    },
    watch: {
      info: {
        handler(e) {
          console.log(e);
        },
        deep: true
      },
      userLive:{
        handler(e) {
          console.log('主播数据1',e);
        },
        deep: true
      }
    },
    created() {
      console.log('动画url',this.info.matchLiveVO.animationUrl);
      // 指定比赛被关联的主播信息
      matchBeRelevanceAnchorList({
       matchId:this.info.matchId,
        matchType: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.userLive = res.data.data.relevanceMatchAnchorVOList;
          console.log('比赛关联的主播信息',this.userLive);
        }
      })
    },
    data() {
      return {
        activeVideo:2,
        userLive:[]
      }
    },
    methods:{
      progressdata(val){
        return val
      },
      changePlay(e){
        if(e == 2){
          this.activeVideo = e
        }else{
          
          if(this.userLive.length > 0){
            this.$refs.dialogLive.open()
          }else{
            this.$message.error('暂无视频直播')
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .video_tabs{
    width: 1200px;
    height: 72px;
    background: #2B2B2B;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .activeVideo{
      height: 72px;
      background: #111111 !important;
      color: #999  !important;
      transition: all .1s;
    }
    .tabsName{
      width: 600px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;

      img{
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
    }
  }
.video_info{
  width: 1200px;
  height: 528px;
  background: #2B2B2B;
  .setiframe{
    width: 1200px;
    height: 528px;
    background: #2B2B2B;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_videoLive.vue